export default __webpack_public_path__ + "static/media/animated-hero.7af210f4.svg";